var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"inherit"}},[_c('button',{class:_vm.computedType,attrs:{"type":_vm.submit ? 'submit' : 'button'},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("Next")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }